import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ActivitySettings } from '../../../../core/api/models';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import { DropdownList } from 'react-widgets';
import CheckBox from '../../../../components/check-box';

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: ActivitySettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: ActivitySettings;
  error?: string;
}> = (props) => {
  const { control, handleSubmit, errors } = useForm<ActivitySettings>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });

  const renderActivityMinimumDuration = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">
          Activity Minimum Duration
        </label>
        <div className="row">
          <div className="col-6">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: 'Activity Minimum Duration is required',
                  validate: {
                    numberOnly: (value) =>
                      new RegExp('\\d+').test(value) || 'Invalid value',
                    min: (value) =>
                      Number(value) >= 0 || 'Value shoud be positive',
                  },
                }}
                name="activityMinimumDuration.value"
                defaultValue={props.data?.activityMinimumDuration?.value}
                render={({ onChange, value, name }) => (
                  <input
                    type="number"
                    min={0}
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="Activity Minimum Duration"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="activityMinimumDuration.value"
                  />
                )}
              />
              <ErrorMessage>
                {errors.activityMinimumDuration?.value?.message}
              </ErrorMessage>
            </div>
          </div>
          <div className="col-6">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                name="activityMinimumDuration.unit"
                defaultValue={
                  props.data?.activityMinimumDuration?.unit || 'Minutes'
                }
                render={({ onChange, value, name }) => (
                  <DropdownList
                    data={[
                      {
                        label: 'Minutes',
                        value: 'Minutes',
                      },
                      {
                        label: 'Hours',
                        value: 'Hours',
                      },
                      {
                        label: 'Days',
                        value: 'Days',
                      },
                    ]}
                    id="activityMinimumDuration.unit"
                    placeholder="Unit"
                    name={name}
                    defaultValue={'Hours'}
                    value={value}
                    onChange={(val) => onChange(val.value)}
                    textField="label"
                    valueField="value"
                  />
                )}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">Update Activity Settings</h4>
        <div className="row gutter-10">
          {renderActivityMinimumDuration()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
